import { Component, ViewChild } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
//import { LoadingBarService } from '@ngx-loading-bar/core';
import { Router } from '@angular/router';
import { UsersProperties, GetAllProvinceDistrictTehsilCityTown, District } from '../models/UsersProperties';
import { DxDataGridComponent } from 'devextreme-angular';
import { UsersService } from "../Services/users.service";
import { MessageService } from 'primeng/api';
import { Agencies_BranchesProperties } from '../Models/AgencyMasterProperties';
import { environment } from '../../environments/environment';
//import { MessageService } from 'primeng/api';
declare var $;
declare var bootstrap: any;
@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.css']
})
/** UserList component*/
export class UserListComponent {
  constructor(private userService: UsersService, private router: Router, private messageService: MessageService) { }
  @ViewChild('userGrid', { static: false }) dataGrid: DxDataGridComponent;
  userList: UsersProperties[] = [];
  collapsed = false;
  userId = 0;
  selectedValue: string;
  agencyCodeList$: Observable<Agencies_BranchesProperties[]>;
  getAllProvinceDistrictTehsilCityTown = new GetAllProvinceDistrictTehsilCityTown();
  AllDistricts: District[] = [];
  operatingCountry = environment.operatingCountry;
  contentReady = (e) => {
    $(".dx-datagrid-headers").css({ "background-color": "white", "color": "#212529", "font-weight": "bold" });
    if (!this.collapsed) {
      this.collapsed = true;
      e.component.expandRow(["EnviroCare"]);
    }
  };

  ngOnInit() {
    this.LoadUserList();
    this.GetAllProvinceDistrictTehsilCityTown();
  }
  //LoadUserList() {
  //  try {
  //    let loginAgency = "";
  //    if ((localStorage.getItem("AgencyId") != undefined) && (localStorage.getItem("") != "") && (localStorage.getItem("AgencyId") != null)) {
  //      loginAgency = localStorage.getItem("AgencyId")
  //      if ((localStorage.getItem("UserId") != undefined) && (localStorage.getItem("UserId") != "") && (localStorage.getItem("UserId") != null))
  //        this.userId = Number(localStorage.getItem("UserId"));
  //      if (this.userId != 0) {
  //        this.userService.GetAllAgencies(loginAgency, this.userId).subscribe((data) => {
  //          this.agencyCodeList$ = of(data);
  //          this.selectedValue = loginAgency;
  //          this.userService.GetAllUser(loginAgency, this.userId).subscribe((data) => {
  //            this.userList = data;
  //          });

  //        });


  //      }
  //    }
  //  }
  //  catch (e) { }
  //}
  GetAllProvinceDistrictTehsilCityTown() {
    this.userService.GetAllProvinceDistrictTehsilCityTown().subscribe(data => {
      this.getAllProvinceDistrictTehsilCityTown = data;
    })
  }
  totalUsers: number = 0;
  activeUsers: number = 0;
  notActiveUsers: number = 0;
  LoadUserList() {
    try {
      let loginAgency = "";
      if ((localStorage.getItem("AgencyId") != undefined) && (localStorage.getItem("") != "") && (localStorage.getItem("AgencyId") != null)) {
        loginAgency = localStorage.getItem("AgencyId")
        if ((localStorage.getItem("UserId") != undefined) && (localStorage.getItem("UserId") != "") && (localStorage.getItem("UserId") != null))
          this.userId = Number(localStorage.getItem("UserId"));
        if (this.userId != 0) {
          this.userService.GetAllAgencies(loginAgency, this.userId).subscribe((data) => {
            this.agencyCodeList$ = of(data);
            this.selectedValue = loginAgency;
            this.userService.GetAllUser(loginAgency, this.userId).subscribe((data) => {
              this.userList = data;
              this.userList.sort(this.customSorting);
              this.activeUsers = this.userList.filter(row => row.status === true).length;
              this.notActiveUsers = this.userList.filter(row => row.status === false).length;
              this.totalUsers = this.userList.length;
            });

          });


        }
      }
    }
    catch (e) { }
  }
  customSorting(a: any, b: any): number {
    if (a.status === b.status) {
      return 0;
    }
    if (a.status === true) {
      return -1;
    }
    return 1;
  }

  public Edit_Click(userId,status,agencyId) {
    if (status == true) {
      localStorage.setItem('AgencyListId', agencyId);
      localStorage.setItem('UserListId', userId);
      this.router.navigateByUrl('/users');
    }
  }

  AddNewUser() {
    try {
      this.router.navigateByUrl('/users');
    }
    catch (e) { }

  }

  AgencyCodeChange(value: string) {
    try {
      if (value != "" && value != null && value != undefined) {
        this.userService.GetAllUser(value, this.userId).subscribe((data) => {
          this.userList = data;
          this.userList.sort(this.customSorting);
          this.activeUsers = this.userList.filter(row => row.status === true).length;
          this.notActiveUsers = this.userList.filter(row => row.status === false).length;
          this.totalUsers = this.userList.length;
        });
      }
    }
    catch (e) { }
  }

  changeStatus(userId, checkbox: HTMLInputElement) {
    // checkbox.checked contains the latest value means new value;
    const previousValue = !checkbox.checked;
    const newValue = !previousValue;

    this.userService.UpdateUserStatus(userId, newValue, this.userId)
      .subscribe((statusdata) => {

        if (statusdata) {
          // success
          this.LoadUserList();
        } else {
          // backend rejected → revert UI
          checkbox.checked = previousValue;
          this.messageService.add({severity: 'error',summary: 'Rejected',detail: 'Status Not Changed'});
        }
      }, error => {
        // API failed → also revert UI
        checkbox.checked = previousValue;
        this.messageService.add({severity: 'error',summary: 'Error',detail: 'Something went wrong'});
      });
  }

  columns = [
    { dataField: 'userId', caption: 'ID', alignment: 'center' },
    { dataField: 'firstName', caption: 'Name', alignment: 'center' },
    { dataField: 'email', caption: 'Email', alignment: 'center' },
    { dataField: 'designation', caption: 'Designation', alignment: 'center' },
    { dataField: 'creationDate', caption: 'Creation Date', alignment: 'center' },
    {
      dataField: 'status', caption: 'Status', alignment: 'center',
      cellTemplate: this.getCellTemplate(),
      lookup: {
        dataSource: [
          { value: true, text: 'Active' },
          { value: false, text: 'Inactive' },
        ],
        valueExpr: 'value',
        displayExpr: 'text',
      },
    },
    { caption: 'Action', alignment: 'center', cellTemplate: this.getActionCellTemplate(), },
  ];
  getCellTemplate() {
    return (container: any, options: any) => {
      let data = options.data;
      const outerDiv = document.createElement('div');
      outerDiv.setAttribute('dxTemplate', "let data of 'cellTemplate'");
      const innerDiv = document.createElement('div');
      innerDiv.className = 'custom_margin';
      const label = document.createElement('label');
      label.className = 'switch';
      const checkbox = document.createElement('input');
      checkbox.type = 'checkbox';
      checkbox.disabled = data.isMasterAdmin;
      checkbox.checked = data.status;
      checkbox.onchange = () => this.changeStatus(data.userId, checkbox);
      const span = document.createElement('span');
      label.appendChild(checkbox);
      label.appendChild(span);
      innerDiv.appendChild(label);
      outerDiv.appendChild(innerDiv);
      container.appendChild(outerDiv);
    };
  }
  //getActionCellTemplate() {
  //  return (container: any, options: any) => {
  //    const data = options.data;
  //    const outerDiv = document.createElement('div');
  //    outerDiv.setAttribute('dxTemplate', "let data of 'actionCellTemplate'");
  //    const anchor = document.createElement('a');
  //    anchor.href = '';
  //    anchor.onclick = (event) => {
  //      event.preventDefault();
  //      this.Edit_Click(data.userId, data.status);
  //    };
  //    const icon = document.createElement('i');
  //    icon.className = 'uil uil-edit action-class';
  //    anchor.appendChild(icon);
  //    outerDiv.appendChild(anchor);
  //    container.appendChild(outerDiv);
  //  };
  //}
  getActionCellTemplate() {
    return (container: any, options: any) => {
      const data = options.data;

      const outerDiv = document.createElement('div');
      outerDiv.style.display = 'flex';
      outerDiv.style.gap = '10px';

      // Get user role from localStorage
      const loginRole = localStorage.getItem("LoginUserRoleName");

      // ------------------------------------
      // Always show EDIT button
      // ------------------------------------
      const editAnchor = document.createElement('a');
      editAnchor.href = '';
      editAnchor.onclick = (event) => {
        event.preventDefault();
        this.Edit_Click(data.userId, data.status, data.agency_branchId);
      };

      const editIcon = document.createElement('i');
      editIcon.className = 'uil uil-edit action-class';
      editAnchor.appendChild(editIcon);
      outerDiv.appendChild(editAnchor);

      // ---------------------------------------------------
      // Show second button only for specific roles
      // ---------------------------------------------------
      const allowedRoles = ['Administrator', 'Operation Manager'];

      if (allowedRoles.includes(loginRole) && this.operatingCountry === "Pakistan") {
        const addAnchor = document.createElement('a');
        addAnchor.href = '';
        addAnchor.onclick = (event) => {
          event.preventDefault();
          this.CheckDistrict_Click(data.userId, data.status);
        };

        const addIcon = document.createElement('i');
        addIcon.className = 'uil uil-plus-circle action-class';
        addAnchor.appendChild(addIcon);
        outerDiv.appendChild(addAnchor);
      }

      // Append to container
      container.appendChild(outerDiv);
    };
  }

  currentUserId: number | null = null;
  CheckDistrict_Click(userId, status) {
    if (status == true) {
    
      //console.log('button click ' + userId);
      this.userService.GetUserByID(userId).subscribe((data) => {
        if (data != undefined && data != null) {
          let accessToDistrictIDs = '';
              accessToDistrictIDs = data.accessDistrictsIds;

          if (accessToDistrictIDs) {
            this.selectedDistricts = accessToDistrictIDs
              .split(',')
              .map(id => Number(id.trim()));
          } else {
            this.selectedDistricts = [];
          }
        }
      })
      ///get all district and shows like mutliple selection
      this.currentUserId = userId; 
      this.AllDistricts = this.getAllProvinceDistrictTehsilCityTown.districts;
     /// console.log(this.AllDistricts);
      const modal = new bootstrap.Modal(document.getElementById('districtModal'));
      modal.show();
    }
  }
  selectedDistricts: number[] = [];
  SaveUserDistricts() {
    if (!this.currentUserId) return;

    const payload = {
      userId: this.currentUserId,
      districtIds: this.selectedDistricts
    };

    this.userService.UpdateUserDistricts(payload).subscribe({
      next: (res) => {
        if (res) {
         // this.messageService.add({ severity: 'success', summary: 'Access to district saved successfully!', detail: "123" });
          //console.log("Update successful");
        } else {
          //this.messageService.add({ severity: 'error', summary: 'an error occrued in saving record!', detail: "" });
          //console.log("Update failed");
        }
        const modal = document.getElementById('districtModal');

        if (modal) {
          modal.classList.remove('show');
          modal.style.display = 'none';
          modal.setAttribute('aria-hidden', 'true');
          modal.removeAttribute('aria-modal');
        }

        document.body.classList.remove('modal-open');

        const backdrop = document.querySelector('.modal-backdrop');
        if (backdrop) {
          backdrop.remove();
        }
        setTimeout(() => {
          this.messageService.add({ severity: 'success', summary: 'Access to district saved successfully!', detail: "saved" });
        }, 300);
      
      },
      error: (err) => {
        console.error("Error:", err);
      }
    });
  }


}
